var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _vm._l(_vm.list, function(item) {
            return [
              _c(
                "el-col",
                {
                  key: item.grid_no,
                  staticStyle: { padding: "8px" },
                  attrs: { xs: 12, sm: 8, md: 8, lg: 8, xl: 6 }
                },
                [
                  _c(
                    "el-card",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _vm._v(
                                  " 格口号：" + _vm._s(item.grid_name) + " "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticStyle: { padding: "2px 0" } }, [
                        _c("span", { staticStyle: { color: "#333" } }, [
                          _vm._v("分播方式：")
                        ]),
                        _vm._v(_vm._s(item.method_text) + "\n          ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { padding: "2px 0" } }, [
                        _c("span", { staticStyle: { color: "#333" } }, [
                          _vm._v("格口配置：")
                        ]),
                        _vm._v(_vm._s(item.method_type_text) + "\n          ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { padding: "2px 0" } }, [
                        _c("span", { staticStyle: { color: "#333" } }, [
                          _vm._v("容器号：")
                        ]),
                        _vm._v(_vm._s(item.box_no) + "\n          ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { padding: "2px 0" } }, [
                        _c("span", { staticStyle: { color: "#333" } }, [
                          _vm._v("已播：")
                        ]),
                        _vm._v(_vm._s(item.cut_num) + "\n          ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "2px 0",
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.handleViewGrid(item)
                                }
                              }
                            },
                            [_vm._v("\n              查看格口\n            ")]
                          ),
                          _vm._v(" "),
                          [
                            _vm.constantMap.NORMAL,
                            _vm.constantMap.STOCK_SEPARATE
                          ].includes(item.method_type)
                            ? [
                                item.box_no
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleChangeBox(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                更换容器\n              "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleBindBox(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                绑定容器\n              "
                                        )
                                      ]
                                    )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7230c9c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7230c9c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/machine/components/ReturnAndExchangeCast.vue
// module id = null
// module chunks = 